import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useDeadline } from "../../../contexts/DeadlineContext";
const GenralSetting = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { offButton, abstractHomeSetup ,getAbstractDeadLineStatus } = useDeadline();
    const [comapanyLogo, setCompanyLogo] = useState("");
    const [comapanyHeader, setCompanyHeader] = useState("");
    const [comapanyFooter, setCompanyFooter] = useState("");
    const [settings, setSettings] = useState({
        COMPANY_NAME: '',
        COMPANY_CONTAC: '',
        COMPANY_ADDRESS: '',
        COMPANY_STATE: '',
        COMPANY_CITY: '',
        COMPANY_POSTAL_CODE: '',
        COMPANY_EMAIL: '',
       
       
    });
   

    useEffect(() => {
        const eventid = localStorage.getItem('eventid');

        axios.get(`/api/get-setting/${eventid}`)
            .then(response => {
                const settingsData = response.data.settings;
                setSettings(settingsData);
            })
            .catch(error => {
                console.error('Error fetching email settings:', error);
            });
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    };
   

    const StoreSmtpSetting = (e) => {
        e.preventDefault();
        

        const data = {
            eventid,
            settings,
            comapanyLogo,
            comapanyHeader,
            comapanyFooter,


        };
       
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/configuration-setting`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                  
                    history.push('/admin/email/setting');
                }
                // else {
                //     setAddSmtpSetting({ ...addSmtpSetting, error_list: res.data.validate_error })
                // }
            });
        });


    }
   



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }



    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        // component={Link}
                        // to="#"
                        onClick={() => history.goBack()}>
                        BAck
                    </Button>

                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            General Setting
                            <Button sx={{ float: 'right',  backgroundColor: backGroundButtonByEvent, ":hover": { color: "white" } }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/email/setting"  >
                                Email Setting
                            </Button>
                            <Button sx={{ marginRight: '2%',  backgroundColor: backGroundButtonByEvent, float: 'right', ":hover": { color: "white" } }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/test/email"  >
                              Test  Email 
                            </Button>
                            

                        </Typography>
                        <Box component="form" onSubmit={StoreSmtpSetting} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>


                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company Name"
                                        autoFocus
                                        name='COMPANY_NAME'
                                        value={settings.COMPANY_NAME || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company Email"
                                        autoFocus
                                        name= 'COMPANY_EMAIL'
                                        placeholder="event@event.com"
                                        value={settings.COMPANY_EMAIL || ""}
                                        onChange={handleChange} />
                                </Grid>
                               
                               
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company Contact"
                                        autoFocus
                                        placeholder="00966"
                                        name='COMPANY_CONTACT' 
                                        value={settings.COMPANY_CONTACT || ""}
                                        onChange={handleChange} />
                                </Grid>

                               

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company Address"
                                        autoFocus
                                        name='COMPANY_ADDRESS'
                                        value={settings.COMPANY_ADDRESS || ""}
                                        onChange={handleChange} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company State"
                                        autoFocus
                                        name='COMPANY_STATE'
                                        value={settings.COMPANY_STATE || ""}
                                        onChange={handleChange} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company City"
                                        autoFocus
                                        name='COMPANY_CITY'
                                        value={settings.COMPANY_CITY || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Company Postal Code"
                                        autoFocus
                                        name='COMPANY_POSTAL_CODE'
                                        value={settings.COMPANY_POSTAL_CODE || ""}
                                        onChange={handleChange} />
                                </Grid>

                                {/* <Grid item xs={6} >
                                <span>Company Logo</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file"  onChange={(e) => setCompanyLogo(e.target.files[0])}/>
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br/><br/>
                                       
                                        {
                                            !settings.COMPANY_LOGO ?
                                                <span>No Logo Uploaded</span> :
                                                <><img src={`${settings.BASE_URL}/settings/${settings.COMPANY_LOGO}`} width="150" height="150" />
                                                </>
                                        }
                                    </label>
                                   
                                </Grid> */}
                                <Grid item xs={6} >
                                <span>Company Logo</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file"  onChange={(e) => setCompanyLogo(e.target.files[0])}/>
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br/><br/>
                                       
                                        {
                                            !settings.COMPANY_LOGO ?
                                                <span>No Logo Uploaded</span> :
                                                <><img src={settings.COMPANY_LOGO} width="150" height="150" />
                                                </>
                                        }
                                    </label>
                                   
                                </Grid>
                                <Grid item xs={6} >
                                <span>Company Header</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file"  onChange={(e) => setCompanyHeader(e.target.files[0])}/>
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br/><br/>
                                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                        Recommended image size: 1280px (width) × 552 (height)
                                        <br/>
                                        Extention: jepg
                                    </Typography>
                                       
                                        {
                                            !settings.COMPANY_HEADER  ?
                                                <span>No Header Uploaded</span> :
                                                <><img src={settings.COMPANY_HEADER} width="350" height="150" />
                                                </>
                                        }
                                    </label>
                                    
                                </Grid>

                                <Grid item xs={6} >
                                <span>Company Footer</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file"  onChange={(e) => setCompanyFooter(e.target.files[0])}/>
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br/><br/>
                                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                        Recommended image size: 1280px (width) × 552 (height)
                                        <br/>
                                        Extention: jepg
                                    </Typography>
                                       
                                        {
                                            !settings.COMPANY_FOOTER  ?
                                                <span>No Footer Uploaded</span> :
                                                <><img src={settings.COMPANY_FOOTER} width="350" height="150" />
                                                </>
                                        }
                                    </label>
                                   
                                </Grid>




                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5,  backgroundColor: backGroundButtonByEvent, }} >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card >
            </Box >
        </div >
    );
}

export default GenralSetting;
